<app-processing [visible]="!pageVars.isReady"></app-processing>

<div class="mt-3">
  <p-card header="Role Permissions" [style]="{ display: 'inline-block', width: 'auto', 'margin-right': '1rem' }">
    <div>
      <p-select
        [options]="roles"
        [(ngModel)]="selectedRole"
        optionLabel="name"
        placeholder="Select a Role"
        (onChange)="roleSelected()"
        appendTo="body" />
      <p-button class="ml-2" label="Save" severity="success" (onClick)="savePermissions()" [disabled]="!pageVars.saveEnabled" />
    </div>
    <div class="mt-1">
      <p-table
        [value]="permissions"
        [(selection)]="selectedPermissions"
        dataKey="id"
        class="table-sm"
        [tableStyle]="{ 'min-width': '50rem', 'width': '50vw' }">
        <ng-template #header>
          <tr>
            <th></th>
            <th>Description</th>
          </tr>
        </ng-template>
        <ng-template #body let-permission>
          <tr>
            <td>
              <p-tableCheckbox [value]="permission"></p-tableCheckbox>
            </td>
            <td>{{ permission.description }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-card>

  <p-card header="Users Update" [style]="{ display: 'inline-block', width: 'auto', 'vertical-align': 'top' }">
    <div class="mt-2">
      <p-button class="ml-2" label="Update Users" severity="success" (onClick)="updateAppUserTable()" />
    </div>
  </p-card>
</div>
